import { FormControlValidator } from '../use-form-control';

export function RequiredFieldValidator(errorMessage?: string): FormControlValidator {
  return (val) => {
    if (val === null || val === undefined || Number.isNaN(val) || (typeof val === 'string' && val.trim() === '')) {
      return {
        valid: false,
        errors: [{ msg: errorMessage || 'This field is required' }],
      };
    }
    return {
      valid: true,
    };
  };
}

export function RequiredIfCondition(cond: () => boolean, errorMessage?: string): FormControlValidator {
  return (val) => {
    if (cond() && (val === null || val === undefined || val === '' || Number.isNaN(val))) {
      return {
        valid: false,
        errors: [{ msg: errorMessage || 'This field is required' }],
      };
    }
    return {
      valid: true,
    };
  };
}
